




































import { Vue, Component, Watch } from 'vue-property-decorator'
import { PointingSessionStore } from '@/pointing/PointingSessionStore'
import Loading from '@/app/Loading.vue'
import { FACILITATE_ROUTE_NAME } from '@/navigation/router'
import { newUser } from '@/user/user'
import { AppStore } from '@/app/AppStore'
import { createSession } from '@/pointing/pointing'

@Component({
  components: {
    Loading
  }
})
export default class NewSession extends Vue {
  facilitatorName: string = ''

  facilitatorHandle: string = ''

  facilitatorPoints: string = 'false'

  creatingSession: boolean = false

  get isSignedIn(): boolean {
    return this.$store.state.profile.signedIn
  }

  get sessionActive(): boolean {
    return !!this.$store.state.pointingSession.currentSession
  }

  get disableSubmit(): boolean {
    return !this.isSignedIn && this.facilitatorName === ''
  }

  get hasConnectionId(): boolean {
    return !!this.$store.state.pointingSession.connectionId
  }

  mounted() {
    this.$store.dispatch(PointingSessionStore.ACTION_END_SESSION)
  }

  async startSession() {
    this.creatingSession = true
    const facilitatorName = this.isSignedIn ? this.$store.state.profile.remoteProfile.name : this.facilitatorName
    const facilitatorHandle = this.isSignedIn ? this.$store.state.profile.remoteProfile.handle : this.facilitatorHandle
    const facilitatorPoints = this.facilitatorPoints === 'true'
    const request = {
      connectionId: this.$store.state.pointingSession.connectionId,
      facilitator: newUser(facilitatorName, facilitatorHandle),
      facilitatorPoints: facilitatorPoints
    }
    try {
      const session = await createSession(this.$store.state.profile.authToken, request)
      await this.$store.commit(PointingSessionStore.MUTATION_SET_SESSION_ID, session.sessionId)
      await this.$store.commit(PointingSessionStore.MUTATION_SET_SESSION, session)
    } catch (e) {
      this.creatingSession = false
      await this.$store.dispatch(AppStore.ACTION_REGISTER_REMOTE_ERROR, 'Error creating session')
    }
  }

  @Watch('sessionActive')
  currentSessionChanged() {
    if (this.sessionActive) {
      this.$router.push({
        name: FACILITATE_ROUTE_NAME,
        params: {
          sessionId: this.$store.state.pointingSession.currentSession.sessionId,
          facilitatorSessionKey: this.$store.state.pointingSession.currentSession.facilitatorSessionKey
        }
      })
    }
  }
}
